/**
 * @description
 * @author: 菩萨蛮
 * @date 2020/9/17 11:50 上午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */

import { getVisible } from './utils';


export default class TableFactory {
  constructor(json) {
    // 初始化数据
    this.json = json;
  }

  initData() {
    const list = Object.keys(this.json).map(e => ({
      param: e,
      ...this.json[e]
    }));

    const sortCallback = (obj1, obj2) => {
      const getSort = sort => (sort === undefined ? 0 : sort);
      return getSort(obj1.sort) - getSort(obj2.sort);
    };

    const tableItems = list
      .filter(e => getVisible(e.visible, 'table', true))
      .sort(sortCallback)
      .map(item => ({
        label: item.title,
        prop: item.param,
        type: item.type,
        width: item.style ? item.style.width : undefined,
        fixed: item.style ? item.style.fixed : undefined,
        overflow: item.style ? item.style.overflow : false,
        fieldIsShow: item.fieldIsShow
      }));
    const search = list.filter(item => item.search === true).map(item => ({
      name: item.title,
      param: item.param,
      type: item.type,
      isShow: item.isShow,
      selectList: item.selectList,
      searchType: item.searchType
    }));

    const boxSearchItems = list.filter(item => item.boxSearch === true).map(item => ({
      name: item.title,
      param: item.param
    }));

    const moreSearchItems = list.filter(item => item.moreSearch === true).map(item => ({
      name: item.title,
      param: item.param,
      type: item.moreSearchType,
      selectList: item.selectList,
      defaultSearchValue: item.defaultSearchValue,
    }));

    return {
      tableItems,
      search,
      boxSearchItems,
      moreSearchItems
    };
  }
}
